import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {sum}            from "@Common/utils/collections";

export const NcoaFailedCountLogic = ({mailingListIds, next: rootNext}) => cs(
    consumeContext("mailingLists"),
    ["count", ({mailingLists}, next) => next(
        !mailingLists.value ? null : sum(mailingListIds, (id) => +(mailingLists.value.find((ml) => ml.id == id)?.failedCount || 0))
    )],
    ["step1", ({count}, next) => rootNext({
        count,
        next,
    })],

    ({step1, count}) => step1.next({
        count,
        itemEditor: {
            $name: "NCOA failed count",
            errorsHandling: {
                highlightErrors: () => {
                    alert("Calculating total failed addresses count");
                },
            },
            valid: count != null,
        }
    })
);

